// eslint-disable-next-line no-shadow
export const RestrictionTypes = ['Mint', 'TradeFDEX', 'TradeOther'] as const
export type RestrictionType = (typeof RestrictionTypes)[number]

export const KYCComplianceModuleAbi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'address',
        name: 'authKeeper',
        type: 'address',
      },
    ],
    name: 'AuthKeeperSet',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'address[]',
        name: 'fDEXAddresses',
        type: 'address[]',
      },
    ],
    name: 'FDEXAddressesAdded',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'address[]',
        name: 'fDEXAddresses',
        type: 'address[]',
      },
    ],
    name: 'FDEXAddressesRemoved',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint8',
        name: 'version',
        type: 'uint8',
      },
    ],
    name: 'Initialized',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'enum KYCComplianceModule.RestrictionType',
        name: 'restrictionsType',
        type: 'uint8',
      },
      {
        components: [
          {
            internalType: 'bool',
            name: 'NotAllowed',
            type: 'bool',
          },
          {
            internalType: 'enum AuthKeeper.KYCLevel',
            name: 'MinKYCLevel',
            type: 'uint8',
          },
          {
            internalType: 'bool',
            name: 'OFAC',
            type: 'bool',
          },
          {
            internalType: 'bool',
            name: 'blacklist',
            type: 'bool',
          },
        ],
        indexed: false,
        internalType: 'struct KYCComplianceModule.Restrictions',
        name: 'restrictions',
        type: 'tuple',
      },
    ],
    name: 'RestrictionsUpdated',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'address',
        name: 'sanctionsList',
        type: 'address',
      },
    ],
    name: 'SanctionsListSet',
    type: 'event',
  },
  {
    inputs: [],
    name: 'KYC_MAINTAINER_ROLE',
    outputs: [
      {
        internalType: 'bytes32',
        name: '',
        type: 'bytes32',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'KYC_TOPIC',
    outputs: [
      {
        internalType: 'bytes32',
        name: '',
        type: 'bytes32',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'tokenF_',
        type: 'address',
      },
      {
        internalType: 'address',
        name: 'authKeeper_',
        type: 'address',
      },
      {
        internalType: 'address',
        name: 'sanctionsList_',
        type: 'address',
      },
      {
        internalType: 'address[]',
        name: 'fDEXAddresses_',
        type: 'address[]',
      },
      {
        components: [
          {
            internalType: 'bool',
            name: 'NotAllowed',
            type: 'bool',
          },
          {
            internalType: 'enum AuthKeeper.KYCLevel',
            name: 'MinKYCLevel',
            type: 'uint8',
          },
          {
            internalType: 'bool',
            name: 'OFAC',
            type: 'bool',
          },
          {
            internalType: 'bool',
            name: 'blacklist',
            type: 'bool',
          },
        ],
        internalType: 'struct KYCComplianceModule.Restrictions',
        name: 'mintRestrictions_',
        type: 'tuple',
      },
      {
        components: [
          {
            internalType: 'bool',
            name: 'NotAllowed',
            type: 'bool',
          },
          {
            internalType: 'enum AuthKeeper.KYCLevel',
            name: 'MinKYCLevel',
            type: 'uint8',
          },
          {
            internalType: 'bool',
            name: 'OFAC',
            type: 'bool',
          },
          {
            internalType: 'bool',
            name: 'blacklist',
            type: 'bool',
          },
        ],
        internalType: 'struct KYCComplianceModule.Restrictions',
        name: 'fDEXRestrictions_',
        type: 'tuple',
      },
      {
        components: [
          {
            internalType: 'bool',
            name: 'NotAllowed',
            type: 'bool',
          },
          {
            internalType: 'enum AuthKeeper.KYCLevel',
            name: 'MinKYCLevel',
            type: 'uint8',
          },
          {
            internalType: 'bool',
            name: 'OFAC',
            type: 'bool',
          },
          {
            internalType: 'bool',
            name: 'blacklist',
            type: 'bool',
          },
        ],
        internalType: 'struct KYCComplianceModule.Restrictions',
        name: 'otherRestrictions_',
        type: 'tuple',
      },
    ],
    name: '__KYCComplianceModule_init',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'bytes32',
        name: 'claimTopicKey_',
        type: 'bytes32',
      },
      {
        internalType: 'bytes32[]',
        name: 'claimTopics_',
        type: 'bytes32[]',
      },
    ],
    name: 'addClaimTopics',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address[]',
        name: 'fDEXAddresses_',
        type: 'address[]',
      },
    ],
    name: 'addToFDEXAddresses',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'bytes4',
        name: 'selector_',
        type: 'bytes4',
      },
    ],
    name: 'calculateClaimTopicKey',
    outputs: [
      {
        internalType: 'bytes32',
        name: '',
        type: 'bytes32',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'getAuthKeeper',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'bytes32',
        name: 'claimTopicsKey_',
        type: 'bytes32',
      },
    ],
    name: 'getClaimTopics',
    outputs: [
      {
        internalType: 'bytes32[]',
        name: '',
        type: 'bytes32[]',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'offset_',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'limit_',
        type: 'uint256',
      },
    ],
    name: 'getFDEXAddresses',
    outputs: [
      {
        internalType: 'address[]',
        name: '',
        type: 'address[]',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: 'bytes4',
            name: 'selector',
            type: 'bytes4',
          },
          {
            internalType: 'address',
            name: 'from',
            type: 'address',
          },
          {
            internalType: 'address',
            name: 'to',
            type: 'address',
          },
          {
            internalType: 'uint256',
            name: 'amount',
            type: 'uint256',
          },
          {
            internalType: 'address',
            name: 'operator',
            type: 'address',
          },
          {
            internalType: 'bytes',
            name: 'data',
            type: 'bytes',
          },
        ],
        internalType: 'struct ITokenF.Context',
        name: 'ctx_',
        type: 'tuple',
      },
    ],
    name: 'getRestrictionType',
    outputs: [
      {
        internalType: 'enum KYCComplianceModule.RestrictionType',
        name: '',
        type: 'uint8',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'enum KYCComplianceModule.RestrictionType',
        name: 'restrictionsType_',
        type: 'uint8',
      },
    ],
    name: 'getRestrictions',
    outputs: [
      {
        components: [
          {
            internalType: 'bool',
            name: 'NotAllowed',
            type: 'bool',
          },
          {
            internalType: 'enum AuthKeeper.KYCLevel',
            name: 'MinKYCLevel',
            type: 'uint8',
          },
          {
            internalType: 'bool',
            name: 'OFAC',
            type: 'bool',
          },
          {
            internalType: 'bool',
            name: 'blacklist',
            type: 'bool',
          },
        ],
        internalType: 'struct KYCComplianceModule.Restrictions',
        name: '',
        type: 'tuple',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'getSanctionsList',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'getTokenF',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'account_',
        type: 'address',
      },
    ],
    name: 'isBlacklisted',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'account_',
        type: 'address',
      },
    ],
    name: 'isFDEXAddress',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: 'bytes4',
            name: 'selector',
            type: 'bytes4',
          },
          {
            internalType: 'address',
            name: 'from',
            type: 'address',
          },
          {
            internalType: 'address',
            name: 'to',
            type: 'address',
          },
          {
            internalType: 'uint256',
            name: 'amount',
            type: 'uint256',
          },
          {
            internalType: 'address',
            name: 'operator',
            type: 'address',
          },
          {
            internalType: 'bytes',
            name: 'data',
            type: 'bytes',
          },
        ],
        internalType: 'struct ITokenF.Context',
        name: 'ctx_',
        type: 'tuple',
      },
    ],
    name: 'isKYCed',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'enum KYCComplianceModule.RestrictionType',
        name: 'restrictionType_',
        type: 'uint8',
      },
      {
        internalType: 'address',
        name: 'account_',
        type: 'address',
      },
    ],
    name: 'isRestricted',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'account_',
        type: 'address',
      },
    ],
    name: 'isSanctioned',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'bytes32',
        name: 'claimTopicKey_',
        type: 'bytes32',
      },
      {
        internalType: 'bytes32[]',
        name: 'claimTopics_',
        type: 'bytes32[]',
      },
    ],
    name: 'removeClaimTopics',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address[]',
        name: 'fDEXAddresses_',
        type: 'address[]',
      },
    ],
    name: 'removeFromFDEXAddresses',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'authKeeper_',
        type: 'address',
      },
    ],
    name: 'setAuthKeeper',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'enum KYCComplianceModule.RestrictionType',
        name: 'restrictionsType_',
        type: 'uint8',
      },
      {
        components: [
          {
            internalType: 'bool',
            name: 'NotAllowed',
            type: 'bool',
          },
          {
            internalType: 'enum AuthKeeper.KYCLevel',
            name: 'MinKYCLevel',
            type: 'uint8',
          },
          {
            internalType: 'bool',
            name: 'OFAC',
            type: 'bool',
          },
          {
            internalType: 'bool',
            name: 'blacklist',
            type: 'bool',
          },
        ],
        internalType: 'struct KYCComplianceModule.Restrictions',
        name: 'restrictions_',
        type: 'tuple',
      },
    ],
    name: 'setRestrictions',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'sanctionsList_',
        type: 'address',
      },
    ],
    name: 'setSanctionsList',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
] as const
